import React, { useState } from "react";
import { ShieldCheck, Lock, Mail, KeyRound } from "lucide-react";
import LoginBackground from "./LoginBackground";
import { useAuth } from "../context/AuthContext";

export default function Login() {
  const { loginPassword } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const signIn = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      // Be forgiving: allow "demo1" -> "demo1@dotiq.ai"
      let em = email.trim().toLowerCase();
      if (em && !em.includes("@")) em = `${em}@dotiq.ai`;
      await loginPassword(em, password.trim());
    } catch (err) {
      setError(err.message || "Invalid email or password");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="login-shell">
      <LoginBackground />
      <div className="login-card">
        <div className="login-brand">Dot<span>IQ</span></div>
        <div className="login-tag">Correlation Intelligence Sandbox</div>
        <h1 className="login-title">Sign in to the DotIQ design-partner sandbox</h1>
        <p className="login-sub">Explore the live proof-of-concept workspaces — correlated decisions, context graphs and explainable insights.</p>

        <button className="google-btn" onClick={signIn}>
          <svg width="18" height="18" viewBox="0 0 48 48" aria-hidden="true">
            <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"/>
            <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"/>
            <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"/>
            <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"/>
          </svg>
          Continue with Google
        </button>

        <div className="login-note"><Lock size={13} /> Access is restricted to <b>@dotiq.ai</b> accounts.</div>

        <div className="login-divider"><span>or sign in with password</span></div>

        <div className="login-hint">Demo / test accounts (e.g. <b>demo1@dotiq.ai</b>) sign in <b>here</b> — not with Google.</div>

        <form className="pw-form" onSubmit={submit}>
          <label className="pw-field">
            <Mail size={15} />
            <input type="text" inputMode="email" value={email} onChange={(e) => setEmail(e.target.value)}
              placeholder="demo1 (or you@dotiq.ai)" autoComplete="username" autoCapitalize="none" spellCheck="false" />
          </label>
          <label className="pw-field">
            <KeyRound size={15} />
            <input type="password" value={password} onChange={(e) => setPassword(e.target.value)}
              placeholder="Password" autoComplete="current-password" />
          </label>
          {error && <div className="pw-error">{error}</div>}
          <button type="submit" className="pw-submit" disabled={busy}>{busy ? "Signing in…" : "Sign in"}</button>
        </form>
      </div>
      <div className="login-foot"><ShieldCheck size={13} /> DotIQ — turn fragmented enterprise signals into explainable decisions</div>
    </div>
  );
}
